<template>
  <div
    style="position: relative"
    class="select-container"
    :class="{ noLabel: !label }"
  >
    <div class="label-tooltip-container">
      <label
        v-if="label"
        class="vs-label"
      >{{ label }}
        <vIconWithTooltip
          v-if="tooltipContent"
          :tooltip-content="tooltipContent"
          :tooltip-placement="'bottom-end'"
          :i-style="'font-size:13px; margin-left: 2px;padding-left:5px'"
          :i-class="'fa fa-info-circle'"
        />
      </label>
    </div>
    <label
      v-if="required"
      class="vs-required-indicator"
    >*</label>
    <v-select
      v-if="multiple"
      class="select-multiple"
      :clearable="clearable"
      multiple
      :reduce="(obj) => obj.id"
      :filterable="filterable"
      label="name"
      :placeholder="placeholder"
      :class="{ filled: hasValue, multiple: true }"
      :value="values"
      :options="options"
      :disabled="disabled"
      @search:focus="$emit('focus')"
      @input="(vals) => $emit('input', vals)"
      @search="(searchQuery) => $emit('search', searchQuery)"
    />
    <v-select
      v-else
      class="select-single"
      :clearable="clearable"
      :placeholder="placeholder"
      :reduce="(obj) => obj.id"
      :filterable="filterable"
      label="name"
      :class="{ filled: hasValue, noLabel: !label, disabled: disabled }"
      :value="value"
      :options="options"
      :searchable="searchable"
      :disabled="disabled"
      :no-drop="noDrop"
      @input="(val) => $emit('input', val)"
      @search="(searchQuery) => $emit('search', searchQuery)"
      @search:focus="$emit('search:focus')"
      @search:blur="$emit('search:blur')"
    />
    <label
      v-if="required && showError"
      class="error-text"
    >{{
      errorMessage
    }}</label>
  </div>
</template>

<script>
import vIconWithTooltip from "@/components/vIconWithTooltip.vue";

export default {
  name: "Vselect",
  components: {
    vIconWithTooltip,
  },
  props: {
    options: Array,

    value: String,
    values: Array,
    label: String,
    required: Boolean,
    showError: Boolean,
    errorMessage: String,

    multiple: Boolean,

    disabled: {
      type: Boolean,
      default: false,
    },
    searchable: {
      type: Boolean,
      default: true,
    },
    // Used to disable client-side filtering when entering a search term
    filterable: {
      type: Boolean,
      default: true,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    noDrop: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: ""
    },
    tooltipContent:{
      type: String,
      default: ""
    },
  },
  computed: {
    hasValue: function() {
      if (this.multiple) {
        return this.values && this.values.length > 0;
      }
      else {
        return (
          this.value != null && this.value != "" && this.value != undefined
        );
      }
    },
  },
  created() {
    let isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
    if (isFirefox) {
      $(".select-container .vs__selected-options .vs__search").addClass(
        "is-firefox"
      );
    }
  },
};
</script>

<style>
.label-tooltip-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

.vs-label {
  display: flex;
  align-items: center;
}

.vs-label .fa-info-circle {
  margin-left: 2px;
}

.select-container .vs-label {
  padding-left: 12px;
  padding-top: 7px;
  margin: 0;
  font-family: "Montserrat";
  font-size: 10.5px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  font-weight: 500;
}
.select-container .noLabel {
  padding-top: 7px;
}
.noLabel .dropdown-toggle {
  padding-bottom: 0;
}
.select-container .vs-required-indicator {
  color: #f55753;
  font-family: arial !important;
  font-size: 20px !important;
  position: absolute;
  right: 10px;
  top: 6px;
}
.noLabel .vs-required-indicator {
  top: 11px;
}
.select-container .select-single {
  margin-top: -8px;
}
.select-container .multiple .icon-close {
  color: #ffffff !important;
}
.select-container .multiple .vs__selected {
  color: #ffffff !important;
  font-size: 16px !important;
  font-family: "proxima-nova" !important;
  word-break: break-all;
  display: inline !important;
  background-color: #54c08a !important;
  border-radius: 4px;
  z-index: 0;
  height: 27px;
  padding-top: 2px;
  padding-left: 7px;
}
.select-container .vs__selected-options .vs__search.is-firefox {
  color: #3c4e60 !important;
}
.select-container .vs__selected-options .vs__search {
  color: #6a7992 !important;
}
.select-container .v-select .vs__selected-options {
  flex-wrap: unset;
  padding: 0;
}
.select-container .v-select .vs__selected-options input {
  padding-left: 12px;
  margin: 0;
}
.select-container .v-select .vs__selected-options input::placeholder {
  color: #999999;
  font-family: Arial, sans-serif;
  font-size: 14px;
  font-weight: normal;
}
.select-container .v-select .dropdown-toggle {
  border: none;
  border-radius: 0;
}
.select-container .v-select .dropdown-menu {
  border: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
  border-radius: none !important;
  box-shadow: none !important;
  max-height: 200px !important;
}
.select-container .v-select .dropdown-menu > li:first-child,
.select-container .v-select .dropdown-menu > li:last-child {
  padding: 0;
}
.select-container .v-select .dropdown-menu > .highlight > a {
  background: #f0f0f0;
  color: black;
}
.select-container .v-select .dropdown-menu > li.active > a {
  background-color: white;
}
.select-container .v-select .selected-tag {
  padding-left: 9px;
}
.select-container .v-select .open-indicator {
  align-items: flex-end;
  padding-bottom: 12px;
  width: 20px;
}
.select-container .v-select.open .open-indicator {
  display: none;
}
.select-container .v-select .vs__actions {
  cursor: pointer !important;
  padding: 0;
}
.select-container .vs__search,
.vs__search:focus {
  border: 0px solid #00000000 !important;
}
.select-container
  .v-select.select-multiple.vs--searchable.multiple
  .vs__dropdown-toggle,
.select-container
  .v-select.select-single.vs--single.vs--searchable
  .vs__dropdown-toggle {
  background-color: white !important;
}
.select-container .filled .vs__selected-options {
  margin-bottom: 0 !important;
}
.select-container .vs__dropdown-option {
  color: #757575b8 !important;
  padding: 8px 7px !important;
}
.select-container .v-select.disabled .dropdown-toggle,
.select-container .v-select.disabled .dropdown-toggle .clear,
.select-container .v-select.disabled .dropdown-toggle input,
.select-container .v-select.disabled .selected-tag .close,
.select-container .v-select.disabled .open-indicator {
  background-color: unset;
}
</style>
